import React from 'react';
import { SubtractAlt } from '@carbon/icons-react';

const ProductControls = React.memo(({
  count,
  onAdd,
  onMinus,
}) => {
  if (count === 0) {
    return (
      <button
        type="button"
        className="carta-v7-qty__btn-add"
        onClick={onAdd}
        aria-label="Agregar"
      >
        <span className="carta-v7-qty__plus" aria-hidden="true">+</span>
      </button>
    );
  }

  return (
    <div className="carta-v7-qty__pill">
      <button
        type="button"
        className="carta-v7-qty__btn"
        onClick={onMinus}
        aria-label="Quitar"
      >
        <SubtractAlt size={12} />
      </button>
      <p className="carta-v7-qty__count">{count}</p>
      <button
        type="button"
        className="carta-v7-qty__btn carta-v7-qty__btn--plus"
        onClick={onAdd}
        aria-label="Agregar"
      >
        <span className="carta-v7-qty__plus carta-v7-qty__plus--sm" aria-hidden="true">+</span>
      </button>
    </div>
  );
}, (prevProps, nextProps) => prevProps.count === nextProps.count);

ProductControls.displayName = 'ProductControls';

export default ProductControls;
